import VideoPreviewModal from "./video_preview_modal.js";
import { createElement } from "./dom_utils.js";

function createVideoAttachmentDisplay(attachment) {
  const container = createElement("div", {
    className: "widget_attachment_icon",
    style:
      "cursor: pointer; position: relative; background: rgba(0, 0, 0, 0.1);",
  });

  const video = createElement("video", {
    src: attachment.url,
    style:
      "width: 100% !important; height: 100% !important; object-fit: cover !important;",
  });

  const source = createElement("source", {
    src: attachment.url,
    type: attachment.content_type || "video/mp4",
  });

  video.appendChild(source);

  const playOverlay = createElement("div", {
    style: `
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.3);
    `,
  });

  const playIcon = createElement("img", {
    src: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/play_icon.svg",
    alt: "play",
    style: "width: 16px; height: 16px;",
  });

  playOverlay.appendChild(playIcon);
  container.appendChild(video);
  container.appendChild(playOverlay);

  container.addEventListener("click", (e) => {
    e.stopPropagation();
    const modal = new VideoPreviewModal();
    modal.open(attachment.url);
  });

  return container;
}

export default createVideoAttachmentDisplay;

